import { render, staticRenderFns } from "./CurrentUserGroups.vue?vue&type=template&id=f88f6696"
import script from "./CurrentUserGroups.vue?vue&type=script&lang=ts"
export * from "./CurrentUserGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports